<template>
    <img class="logo h-[60px] w-auto" src="/images/logo.png" alt="Logo" />
</template>
<script setup>
</script>
